import { AvatarColorVariants } from './constants';

export const getColorForLetter = (letter: string) => {
  return AvatarColorVariants[letter as keyof typeof AvatarColorVariants];
};
